import { OfferPreview } from "@justhome/api-core";
import { Locale } from "./i18n";
import { formatLabels, offerLabels } from "./labels";

export const formatYearMonths = (value: number, locale: Locale): string => {
  const labels = formatLabels[locale];
  const years = Math.floor(value / 12);
  const months = value % 12;
  let result = "";

  if (months) {
    const formattedMonths = `${months} ${
      months > 1 ? labels.months : labels.month
    }`;
    result = `${years} ${
      years > 1 ? labels.years : labels.year
    } ${formattedMonths}`;
  } else {
    result = `${years} ${years > 1 ? labels.years : labels.year}`;
  }
  return result;
};

export const formatInterestPeriodRange = (
  offer: OfferPreview,
  locale: Locale,
) => {
  const loans = offer.loans;
  const fixedInterestPeriodInYears = offer.fixedInterestPeriodInYears;
  const labels = offerLabels[locale];
  let interestPeriodRange: { min: number; max: number } | null = null;

  const getYearText = (year: number | undefined) => {
    if (!year) return "";
    return `${year} ${labels.yearsDative}`;
  };

  if (loans && loans.length > 1) {
    const iterestPriods = loans.map((l) => l.fixedInterestPeriodInYears!);
    const min = Math.min(...iterestPriods);
    const max = Math.max(...iterestPriods);
    if (min !== max) {
      interestPeriodRange = { min, max };
    }
  }

  if (interestPeriodRange) {
    return `${interestPeriodRange.min} – ${getYearText(
      interestPeriodRange.max,
    )}`;
  }
  return getYearText(fixedInterestPeriodInYears);
};

export const formatDate = (date: Date, locale: Locale) => {
  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
